<template>
  <div>
    <graph-title />
    <draw-graph ref="drawGraph"/>
  </div>
</template>

<script>
import GraphTitle from "@/components/TitleForOverwrite.vue";
import DrawGraph from "@/components/DrawGraphForOverwrite.vue";

export default {
  name: "create",
  components: {
    GraphTitle,
    DrawGraph
  },
  beforeRouteLeave (to, from, next) {
    const fullscreen_flg = this.$store.state.full_screen_flg;

    if (fullscreen_flg) {
      this.$store.commit('setFullScreenFlg', false);
      this.$refs.drawGraph.scrollLock(false);
      next();
    } else {
      next();
    }
  }
}
</script>